import { render, staticRenderFns } from "./explanationField.vue?vue&type=template&id=88922a14&scoped=true&"
import script from "./explanationField.vue?vue&type=script&lang=js&"
export * from "./explanationField.vue?vue&type=script&lang=js&"
import style0 from "./explanationField.vue?vue&type=style&index=0&id=88922a14&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88922a14",
  null
  
)

export default component.exports